import React, { useEffect, useState } from 'react';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { Problem, WhyNow } from '../components/landing/StatsProblem';
import { Mistakes } from '../components/landing/Mistakes';
import { Method } from '../components/landing/Method';
import { Testimonials } from '../components/landing/Testimonials';
import { About } from '../components/landing/About';
import { Pricing } from '../components/landing/Pricing';
import { ForWhom } from '../components/landing/ForWhom';
import { Apply } from '../components/landing/Apply';
import { Freebie, Faq } from '../components/landing/FreebieFaq';
import { Footer } from '../components/landing/Footer';
import { useSiteConfig } from '../lib/siteConfig';

export default function LandingPage() {
  const { brand_name } = useSiteConfig();

  useEffect(() => {
    document.title = `${brand_name} | 1:1 Aktien-Mentoring für Angestellte`;
  }, [brand_name]);

  return (
    <div className="min-h-screen overflow-x-clip bg-paper font-sans text-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Testimonials />
        <Mistakes />
        <Problem />
        <WhyNow />
        <Method />
        <About />
        <Pricing />
        <ForWhom />
        <Apply />
        <Freebie />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
